export const enum FilterSourceEnum {
    CUSTOM = 'custom',
    SERVICE = 'service'
}
